import type { KbGenerationTemplateListItem } from "../types/gameRuleKbGenerationTemplate";
import { formatIsoDateOnly } from "./displayDate";

export const formatKbGenerationTemplateRowMeta = (
  template: KbGenerationTemplateListItem,
): string => {
  const parts = [
    `${template.sectionCount} section${template.sectionCount === 1 ? "" : "s"}`,
  ];
  if (template.totalVersions > 1) {
    parts.push(`v${template.version}`);
  }
  parts.push(`Updated ${formatIsoDateOnly(template.updatedAt)}`);
  return parts.join(" · ");
};
